// HelpReportButton — Jun 2026.
//
// A small, always-there "Help" button so reporting a problem / contacting the
// team is one tap from anywhere in the app. Opens the shared
// ReportContactModal (general context — bug / billing / idea, with pre-filled
// guidance). Mounted globally in App.js inside <BrowserRouter>.
//
// Hidden on pages that already have their own contact path or a busy bottom
// bar (the public landing page has a footer Contact link; public silo pages
// have a composer pinned to the bottom; auth screens stay clean).
import { useState } from "react";
import { useLocation } from "react-router-dom";
import { Question } from "@phosphor-icons/react";
import ReportContactModal from "@/components/ReportContactModal";

const HIDE_PREFIXES = ["/s/", "/m/", "/wars/arena", "/login", "/signup", "/forgot-password", "/reset-password"];

export default function HelpReportButton() {
  const [open, setOpen] = useState(false);
  const { pathname } = useLocation();

  const hidden = pathname === "/" || HIDE_PREFIXES.some((p) => pathname.startsWith(p));
  if (hidden) return null;

  return (
    <>
      <button
        type="button"
        onClick={() => setOpen(true)}
        data-testid="help-report-button"
        title="Help & report a problem"
        className="fixed bottom-3 left-3 z-[90] inline-flex items-center gap-1 rounded-full border border-[#D8D6D2] bg-white/95 backdrop-blur px-2 py-1 text-[9px] text-[#1C1B1A] shadow-sm hover:shadow-md hover:-translate-y-[1px] transition-all"
      >
        <Question size={8} weight="duotone" className="text-[#C16E5A]" />
        <span className="hidden sm:inline font-medium">Help</span>
      </button>
      <ReportContactModal open={open} onClose={() => setOpen(false)} context="general" />
    </>
  );
}
